<nav mat-tab-nav-bar backgroundColor="primary" [tabPanel]="panel">
    <a mat-tab-link [active]="true" i18n>All Shipments</a>
</nav>
<mat-tab-nav-panel #panel></mat-tab-nav-panel>